/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable import/no-unresolved */
import {
  Container, IconButton, Tooltip,
} from '@airbus/components-react';
import { useRef } from 'react';
import { Help } from '@airbus/icons/react';
import { HELP_CENTRE, HELP_CENTRE_URL } from '../../utils/constants';
import './UserHelp.scss';
import { useAppSelector } from '../../store/hooksTypes';
import { getDisclaimerStatus } from '../../utils/commonMethods/generalMethods';
import { isRequiredForEnv } from '../../utils/commonUtil';

const UserHelp: React.FC = function UserHelp() {
  const buttonRef = useRef(null);
  const { userScope } = useAppSelector((state) => state.authEntrySlice);

  const handleSettingsClick = () => {
    window.open(HELP_CENTRE_URL[userScope]);
  };

  return (
    <Container className="user-Help-Popover-Container">
      <Tooltip
        placement="bottom"
        label={HELP_CENTRE}
        className="tooltip-help-centre"
      >
        <IconButton
          ref={buttonRef}
          disabled={isRequiredForEnv(['pro', 'val']) ? !getDisclaimerStatus() : false}
          onClick={handleSettingsClick}
          aria-haspopup="dialog"
          className="menu-button"
          data-testid="help-click"
          placeholder={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <Help />
        </IconButton>
      </Tooltip>
    </Container>
  );
};
export default UserHelp;
